import { createSlice } from "@reduxjs/toolkit";

export interface DesignSchedule {
  sowFinalized: String;
  schematicSet: String;
  developmentDocumentSet: String;
  constructionDocumentSet: String;
  permitsObtained: String
}

const initialState: DesignSchedule = {
  sowFinalized: "",
  schematicSet: "",
  developmentDocumentSet: "",
  constructionDocumentSet: "",
  permitsObtained: ""
};

export const DesignScheduleSlice = createSlice({
  name: "designScheduleSliceInfo",
  initialState,
  reducers: {
    setDesignSchedule(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setDesignSchedule } = DesignScheduleSlice.actions;

export default DesignScheduleSlice.reducer;
